module.exports = __webpack_public_path__ + "static/media/tiffany.db389147.png";